import getStore from 'services/getStore';

const store = getStore();

const getFontSize = (base, h) => {
  return `
    font-size: ${base + (h > 1 ? h / 10 : 0)}rem;
  `;
  //
};

function halfwayBetween2Numbers(a: number, b: number) {
  return (a + b) / 2;
}

const headingsTable = {
  h1: [4.5, halfwayBetween2Numbers(4.5, 2), 2],
  h2: [3.5, halfwayBetween2Numbers(3.5, 2), 2],
  h3: [3, halfwayBetween2Numbers(3, 2), 2],
  h4: [2.6, halfwayBetween2Numbers(2.6, 2), 2],
  h5: [2, halfwayBetween2Numbers(2, 1.2), 1.2],
  h6: [1.6, halfwayBetween2Numbers(1.6, 1.2), 1.2],
};

export const getLineHeight = (heading: keyof typeof headingsTable, index) => {
  // H1 - 4.5 Rem
  // H2 - 3.5 Rem
  // H3 - 3 Rem
  // H4 - 2.6 Rem
  // H5 - 2 Rem
  // H6 - 1.6 Rem

  const defaultLineHeight = 1.5;
  const { lineHeight = defaultLineHeight } = store.getState().theme;
  const calculatedLineHeight =
    (headingsTable[heading][index] / defaultLineHeight) * lineHeight;

  return `
    line-height: ${calculatedLineHeight}rem;
  `;
};

const headingStyles = ({ h1, h2, h3, h4, h5, h6 }) => `
  h1 {
    ${getFontSize(2, h1)}
    ${getLineHeight('h1', 2)}
  }

  h2 {
    ${getFontSize(1.5, h2)}
    ${getLineHeight('h2', 2)}
  }

  h3 {
    ${getFontSize(1.3, h3)}
    ${getLineHeight('h3', 2)}
   
  }

  h4 {
    ${getFontSize(1, h4)}
    ${getLineHeight('h4', 2)}
  }

  h5 {
    ${getFontSize(1 || 0.8, h5)}
    ${getLineHeight('h5', 2)}
  }

  h6 {
    ${getFontSize(1 || 0.6, h6)}
    ${getLineHeight('h6', 2)}
  }

  @media(min-width: 480px) {
    h1 {
        ${getFontSize(2.5, h1)}
        ${getLineHeight('h1', 1)}
    }

    h2 {
        ${getFontSize(2, h2)}
        ${getLineHeight('h2', 1)}
    }

    h3 {
        ${getFontSize(1.8, h3)}
        ${getLineHeight('h3', 1)}
    }

    h4 {
        ${getFontSize(1.5, h4)}
        ${getLineHeight('h4', 1)}
    }

    h5 {
      ${getFontSize(1, h5)}
      ${getLineHeight('h5', 1)}
    }
  
    h6 {
      ${getFontSize(1 || 0.8, h6)}
      ${getLineHeight('h6', 1)}
    }
}

  @media(min-width: 767px) {
    h1 {
        ${getFontSize(3.5, h1)}
        ${getLineHeight('h1', 0)}
    }

    h2 {
        ${getFontSize(2.5, h2)}
        ${getLineHeight('h2', 0)}
    }

    h3 {
      ${getFontSize(2, h3)}
      ${getLineHeight('h3', 0)}
    }

    h4 {
      ${getFontSize(1.7, h4)}
      ${getLineHeight('h4', 0)}
    }
  
    h5 {
      ${getFontSize(1.2, h5)}
      ${getLineHeight('h5', 0)}
    }
  
    h6 {
      ${getFontSize(1, h6)}
      ${getLineHeight('h6', 0)}
    }
}
`;

export default headingStyles;
